var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 32,
    viewBox: "0 0 26 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.36 31.4624L13.776 17.5734C14.5787 16.6847 15.2667 15.8821 15.84 15.1654C16.442 14.4487 16.8863 13.7464 17.173 13.0584C17.4883 12.3417 17.646 11.5821 17.646 10.7794C17.646 10.3207 17.56 9.86207 17.388 9.4034C17.216 8.94473 16.958 8.5434 16.614 8.1994C16.27 7.82673 15.84 7.54007 15.324 7.3394C14.808 7.11007 14.206 6.9954 13.518 6.9954C12.6007 6.9954 11.7837 7.22474 11.067 7.6834C10.379 8.14207 9.84867 8.78707 9.476 9.6184C9.132 10.4497 8.96 11.4101 8.96 12.4994H1.822C1.822 10.3494 2.26633 8.38573 3.155 6.6084C4.04367 4.83107 5.37667 3.41207 7.154 2.3514C8.96 1.29073 11.153 0.7604 13.733 0.7604C15.5963 0.7604 17.2447 1.04707 18.678 1.6204C20.1113 2.16507 21.301 2.9104 22.247 3.8564C23.2217 4.77373 23.9527 5.7914 24.44 6.9094C24.9273 8.0274 25.171 9.15974 25.171 10.3064C25.171 11.9404 24.7697 13.4454 23.967 14.8214C23.1643 16.1687 22.118 17.4014 20.828 18.5194L13.819 24.7974H25.859V31.4624H0.36Z",
    fill: "#E0861B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.76380cd22eced5a27d5efb391c1e44e0.svg";
export { ForwardRef as ReactComponent };